import { render, staticRenderFns } from "./AttemptsList.vue?vue&type=template&id=60976800&scoped=true&"
import script from "./AttemptsList.vue?vue&type=script&lang=js&"
export * from "./AttemptsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60976800",
  null
  
)

export default component.exports